<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <button
          :class="[
            'tw-inline-flex tw-items-center tw-justify-center  tw-transition-all tw-duration-200 tw-ease-in-out',
            {
              'tw-opacity-50 tw-cursor-not-allowed': isDisabled,
              'tw-cursor-pointer': !isDisabled,
            },
            $attrs.class,
          ]"
          :disabled="isDisabled"
          v-bind="$attrs"
        >
          <Loader2 v-if="loading" class="tw-mr-2 tw-h-4 tw-w-4 tw-animate-spin" />
          <slot></slot>
        </button>
      </TooltipTrigger>
      <TooltipContent v-if="isDisabled">
        {{ t('common.message.customer_archived_tooltip') }}
      </TooltipContent>
      <TooltipContent v-else-if="$attrs.tooltip">
        {{ $attrs.tooltip }}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useCustomerStore } from '@/stores/customer.store';
import { useI18n } from 'vue-i18n';
import { Loader2 } from 'lucide-vue-next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const props = defineProps<{
  /** Show a spinner and disable the button while an action is in flight. */
  loading?: boolean;
}>();

const { t } = useI18n();
const customerStore = useCustomerStore();
const isDisabled = computed(() => customerStore.shouldDisableCustomerActions() || props.loading);
</script>
